import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#070707] border-t border-white/10 mt-24 md:mt-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 border-b border-white/10 pb-16">
          <div className="md:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-[#d40202] font-bold mb-6">
              / Ready when you are
            </div>
            <h3 className="font-display font-black text-4xl md:text-6xl uppercase leading-[0.95] tracking-tighter">
              Let&apos;s put your brand <br />
              <span className="text-[#d40202]">on the map.</span>
            </h3>
            <Link
              to="/contact#inquiry-form"
              data-testid="footer-cta-contact"
              className="mt-8 inline-flex items-center gap-3 bg-[#d40202] hover:bg-white hover:text-black text-white px-6 py-4 text-xs uppercase tracking-[0.2em] font-bold transition-colors"
            >
              Start a Project <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
            </Link>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 font-bold mb-6">
              / Head Office
            </div>
            <address className="not-italic space-y-4 text-zinc-300">
              <div className="flex gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#d40202] shrink-0" />
                <span data-testid="footer-address">
                  L-80/C, Vijay Vihar Phase 2, <br />
                  Rohini Sector 7, New Delhi
                </span>
              </div>
              <div className="flex gap-3">
                <Phone className="w-4 h-4 mt-1 text-[#d40202] shrink-0" />
                <a
                  href="tel:+918601515509"
                  data-testid="footer-phone"
                  className="hover:text-white transition-colors"
                >
                  +91 86015 15509
                </a>
              </div>
              <div className="flex gap-3">
                <Mail className="w-4 h-4 mt-1 text-[#d40202] shrink-0" />
                <div className="flex flex-col">
                  <a
                    href="mailto:info@advedaads.com"
                    data-testid="footer-email-info"
                    className="hover:text-white transition-colors"
                  >
                    info@advedaads.com
                  </a>
                  <a
                    href="mailto:business@advedaads.com"
                    data-testid="footer-email-business"
                    className="hover:text-white transition-colors"
                  >
                    business@advedaads.com
                  </a>
                </div>
              </div>
            </address>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 font-bold mb-6">
              / Explore
            </div>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="hover-line text-zinc-300 hover:text-white" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/#services" className="hover-line text-zinc-300 hover:text-white" data-testid="footer-link-services">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/#about" className="hover-line text-zinc-300 hover:text-white" data-testid="footer-link-about">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover-line text-zinc-300 hover:text-white" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="py-10 overflow-hidden select-none" aria-hidden>
          <div
            className="font-display font-black uppercase leading-none tracking-tighter text-white/[0.04] whitespace-nowrap"
            style={{ fontSize: "clamp(80px, 15vw, 260px)" }}
          >
            ADVEDA
          </div>
        </div>

        {/* Brand mark */}
        <div className="flex items-center gap-4 pt-2 pb-8">
          <span className="inline-flex items-center bg-white px-5 py-3">
            <img
              src="/brand/adveda-logo-light.png"
              alt="AdVeda Advertising"
              className="h-9 md:h-11 w-auto"
              draggable="false"
              data-testid="footer-logo"
            />
          </span>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-6 border-t border-white/10">
          <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">
            © {new Date().getFullYear()} AdVeda Advertising. All rights reserved.
          </p>
          <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">
            Out-of-Home · Tenders · Media Buying
          </p>
        </div>
      </div>
    </footer>
  );
}
